import React, { useEffect, useState } from 'react'
import './project.css'
import { useParams } from 'react-router-dom';
import axios from 'axios';
// import html2canvas from 'html2canvas';
// import jsPDF from 'jspdf';


const Project = () => {
  const { id } = useParams();
  const [Post, setPost] = useState();

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_HOST1}/post/${[id]}`, {
      headers: {
        "Content-Type": "application/json",
        accessToken: localStorage.getItem("accessToken")//bad practise
      },
    }
    )
      .then(response => {
        setPost(response.data);
        console.log(response.data)
      })
      .catch(error => {
        console.error(error);
      });
  }, [id]);

  function size(params) {
    if (params==='L') {
      return 'Large'
    } 
    else if (params==='M') {
      return 'Medium'
    }
    else if (params==='S') {
      return 'Small'
    }
  }


  return (
    <>
      <div className='containera'>
        <div className='header'>
          <img src='/building.png' alt="" />
          <div className='header-info'>
            {Post?.sector_p ? <h1>{Post?.sector_p}</h1> : null}
            {Post?.User.company_name ? <h2>{Post?.User.company_name}</h2> : null}
            <div className='first-two'>
              <div className='location'>
                <img src='/location1.png' alt="" />{Post?.location ? Post?.location : null}
              </div>
              <div className='location'>
                <img src='/location.png' alt="" />{Post?.project_size ? size(Post?.project_size) : null}
              </div>
            </div>
            <div className='three'>
              <div className='size'>
                <img src='/rupees.png' alt="" />{Post?.budget_l ? Post?.budget_l : null}-{Post?.budget_h ? Post?.budget_h : null}
              </div>
              <div className='size'>
                <img src='/duration.png' alt="" />{Post?.duration_l ? Post?.duration_l : null}-{Post?.duration_h ? Post?.duration_h : null} months
              </div>
              <div className='size'>
                <img src='/bag.png' alt="" />{Post?.exp ? Post?.exp : null} years
              </div>
            </div>
          </div>
        </div>
        <div className='second'>
          <div className='about-header'>About Us</div>
          <div className='about'>{Post?.User?.company_desc ? Post?.User?.company_desc : null}</div>

          <div className='about-header'>Social Media Links</div>
          <div className='images'>
            <a href="https://www.linkedin.com/"> {/* Replace with your desired LinkedIn URL */}
              <img src='/linkedin1.png' alt="" />
            </a>
            <a href="https://www.linkedin.com/"> {/* Replace with your desired Website URL */}
              <img src='/website.png' alt="" />
            </a>
          </div>
          <div className='about-header'>Project Description</div>
          <div className='about'>{Post?.project_desc ? Post?.project_desc : null}</div>


          <div className="about-header">Skills</div>
          <div className="skills">
            {Post?.skill ? (Post?.skill.map((data, index) => (<div key={index} className="skill">{data}</div>))) : null}
          </div>
          <div className="buttons">
            <button className="btn send-inquiry"><img src='/inquiry1.png' alt="" />Send Inquiry</button>
            <button className="btn save"><img src='/save.png' alt="" />Save</button>
            <button className="btn download-pdf" onClick={() => alert("wait")}><img src='/download.png' alt="" />Download PDF</button>
          </div>
        </div>
      </div>
    </>
  )
}

export default Project;
